export default "__VITE_ASSET__kVJc4LUr__"